// extracted by mini-css-extract-plugin
export default {"likeButton":"k8-z","unLikedButton":"l8-z","likedButton":"m8-z"};